import script from "./ContactSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactSection.vue?vue&type=script&setup=true&lang=ts"

import "./ContactSection.vue?vue&type=style&index=0&id=213441e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-213441e5"]])

export default __exports__